declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GA_MEASUREMENT_ID = 'G-NLQ2J798RN';

const setupGtag = () => {
  // Don't setup twice
  if (document.querySelector('script[src*="googletagmanager"]')) return;

  // Step 1: Initialize dataLayer and gtag BEFORE loading the Google script
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // Step 2: Send initial config events (queued in dataLayer)
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure'
  });

  // Step 3: Load the Google script (it will process the dataLayer queue)
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);
};

export const initializeAnalytics = () => {
  const analyticsConsent = localStorage.getItem('cookie_analytics');
  if (analyticsConsent !== 'true') return;
  setupGtag();
};

export const loadAnalytics = () => {
  setupGtag();
};
